export const FETCH_USER_INFO_TAG = 'fetch_user_info';

export const USER_ROLES = {
  ADMIN: 'Buyer Administrator',
  APPROVER: 'Buyer Approver',
  SUBMITTER: 'Buyer'
};

export const FAULTINJECT_GET_USER = 'faultinject_getUser';
export const FAULTINJECT_GENERIC_ERROR = 'GENERIC_ERROR';
